module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "category row"
  }, [_c('p', {
    staticClass: "category_title"
  }, [_vm._v(_vm._s(_vm.getCategoryName(_vm.categoryId)))]), _vm._v(" "), _c('div', {
    staticClass: "bar_section"
  }, [_c('div', {
    staticClass: "prev_section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPrevious),
      expression: "hasPrevious"
    }],
    staticClass: "arrow left",
    on: {
      "click": _vm.toPrevious
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "main_section"
  }, _vm._l((_vm.filterdVideos), function(v) {
    return _c('router-link', {
      key: v.ytid,
      staticClass: "video",
      style: ({
        'background-image': 'url(' + v.thumbnail + ')'
      }),
      attrs: {
        "to": {
          name: 'video-player',
          params: {
            ytid: v.ytid
          }
        }
      }
    }, [_c('div', {
      staticClass: "overlay"
    }, [_c('div', {
      staticClass: "caption"
    }, [_c('div', {
      staticClass: "title-bg"
    }, [_c('h4', {
      staticClass: "title"
    }, [_vm._v(_vm._s(v.title))])]), _vm._v(" "), _c('div', {
      staticClass: "note-bg"
    }, [_c('p', {
      staticClass: "note"
    }, [_vm._v(_vm._s(v.note))])])])])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "next_section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasNext),
      expression: "hasNext"
    }],
    staticClass: "arrow right",
    on: {
      "click": _vm.toNext
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-392a76d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoArchivesCategory.vue
// module id = 84
// module chunks = 0